export let templates: any;
templates = {
  en: {
    theory: 6741,
    practice: 6742,
    instruction: 9398,
    scorm: 9919,
  },
  fr: {
    theory: 6743,
    practice: 6744,
    instruction: 9399,
    scorm: 9920,
  },
  nl: {
    theory: 6739,
    practice: 6740,
    instruction: 9397,
    scorm: 9918,
  },
  es: {
    theory: 9395,
    practice: 9396,
    instruction: 9400,
    scorm: 9921,
  },
};

if (window.location.hostname === 'teo.training') {
  templates = {
    en: {
      theory: 6741,
      practice: 6742,
      instruction: 9398,
      scorm: 9919,
    },
    fr: {
      theory: 6743,
      practice: 6744,
      instruction: 9399,
      scorm: 9920,
    },
    nl: {
      theory: 6739,
      practice: 6740,
      instruction: 9397,
      scorm: 9918,
    },
    es: {
      theory: 9395,
      practice: 9396,
      instruction: 9400,
      scorm: 9921,
    },
  };
}
